module.exports = __webpack_public_path__ + "img/arrow_up.a1a4a546.svg";